import styled from 'styled-components';

const Label = styled.span`
    grid-area: label;
`;

export default Label;
